"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTeamNameInput = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const useTeamNameInput = () => {
    const [errors, setErrors] = (0, react_1.useState)({});
    const { data: teams = [] } = (0, teamQuery_1.useGetAllTeamsQuery)();
    const { setTeamName, setIsTeamNameError, setIsSaveBtnDisabled, initialTeamName, teamId, teamName, hasChanges, setHasChanges, } = (0, zustandStore_1.useZustand)(state => ({
        setTeamName: state.setTeamName,
        setIsTeamNameError: state.setIsTeamNameError,
        setIsSaveBtnDisabled: state.setIsSaveBtnDisabled,
        setHasChanges: state.setHasChanges,
        teamName: state.team.teamName,
        teamId: state.team.team?.id,
        teamRequestLimit: state.team.teamRequestLimit,
        initialTeamName: state.team.initialTeamName,
        hasChanges: state.team.hasChanges,
    }));
    (0, react_1.useEffect)(() => {
        return () => {
            setIsTeamNameError(false);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const isDisabled = (teamName === initialTeamName && !hasChanges) || !lodash_1.default.isEmpty(errors);
        setIsSaveBtnDisabled(isDisabled);
    }, [errors, hasChanges, initialTeamName, setIsSaveBtnDisabled, teamName]);
    const validateUniqueTeamName = (value) => {
        if (!value) {
            const errorMessage = strings_1.messageStrings.TEAM_NAME_NOT_EMPTY;
            return { invalid: true, errorMessage };
        }
        const isExistingTeamByName = teams?.some((team) => team.name.toLowerCase() === value.toLowerCase() && team.id !== teamId);
        const errorMessage = isExistingTeamByName ? strings_1.messageStrings.UNIQUE_TEAM_NAME_ERROR_MESSAGE : '';
        return { invalid: isExistingTeamByName, errorMessage };
    };
    const changeTeamName = (_name, value) => {
        setTeamName(value);
        const data = validateUniqueTeamName(value);
        setIsTeamNameError(data.invalid || false);
        setIsSaveBtnDisabled(data.invalid || false);
        setHasChanges(true);
        const errMsg = [];
        if (data.invalid) {
            errMsg.push(data.errorMessage);
            setErrors(prevState => ({
                ...prevState,
                [appConstants_1.teamSettingsErrorFields.teamName]: errMsg,
            }));
        }
        else {
            setErrors({});
        }
    };
    return {
        setTeamName,
        errors,
        setErrors,
        changeTeamName,
    };
};
exports.useTeamNameInput = useTeamNameInput;
